import { memo } from 'react';
import { NAV_ITEM_BOOKMARKS_GROUP_ID } from '../../constants/Bookmarks';
import { GLOBAL_HOME_NAV_ITEM_ID } from '../../constants/globalHome';
import { FavoriteIcon } from '../../nav-ui-components/Icons/FavoritesIcon';
import AppsIcon from '../icons/AppsIcon';
import AutomationsIcon from '../icons/AutomationsIcon';
import BreezeAiIcon from '../icons/BreezeAiIcon';
import CRMDevIcon from '../icons/CRMDevIcon';
import CRMIcon from '../icons/CRMIcon';
import CommerceIcon from '../icons/CommerceIcon';
import CommunityForumIcon from '../icons/CommunityForumIcon';
import ContentIcon from '../icons/ContentIcon';
import DatabaseIcon from '../icons/DatabaseIcon';
import DeveloperDocsIcon from '../icons/DeveloperDocsIcon';
import DeveloperHomeIcon from '../icons/DeveloperHomeIcon';
import DeveloperKeysIcon from '../icons/DeveloperKeysIcon';
import DeveloperProjectsIcon from '../icons/DeveloperProjectsIcon';
import HighlyEngagedLeadIcon from '../icons/HighlyEngagedLeadIcon';
import HomeIcon from '../icons/HomeIcon';
import LibraryIcon from '../icons/LibraryIcon';
import MarketingIcon from '../icons/MarketingIcon';
import NewMarketplaceIcon from '../icons/NewMarketplaceIcon';
import PartnerIcon from '../icons/PartnerIcon';
import ReportingDataIcon from '../icons/ReportingDataIcon';
import TestAccountsIcon from '../icons/TestAccountsIcon';
import TicketIcon from '../icons/TicketIcon';
import WorkspacesIcon from '../icons/WorkspacesIcon';
import ServiceIcon from '../icons/ServiceIcon';
import SalesIcon from '../icons/SalesIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const VerticalNavMenuItemIcon = ({
  id,
  title
}) => {
  let SwitchedIconComponent;
  switch (id) {
    case 'prospecting-new':
    case 'prospecting':
    case 'prospecting-beta':
      SwitchedIconComponent = HighlyEngagedLeadIcon;
      break;
    case 'crm':
      SwitchedIconComponent = CRMIcon;
      break;
    case 'marketing':
      SwitchedIconComponent = MarketingIcon;
      break;
    case 'website':
    case 'web-content':
      SwitchedIconComponent = ContentIcon;
      break;
    case 'service-branch':
      SwitchedIconComponent = ServiceIcon;
      break;
    case 'sales-branch':
      SwitchedIconComponent = SalesIcon;
      break;
    case 'automation':
    case 'automation-branch':
      SwitchedIconComponent = AutomationsIcon;
      break;
    case 'reports-and-data':
    case 'reports':
      SwitchedIconComponent = ReportingDataIcon;
      break;
    case 'data-ops':
      SwitchedIconComponent = DatabaseIcon;
      break;
    case 'breeze-ai':
      SwitchedIconComponent = BreezeAiIcon;
      break;
    case 'library':
      SwitchedIconComponent = LibraryIcon;
      break;
    case 'help-desk':
    case 'help-desk-beta':
      SwitchedIconComponent = TicketIcon;
      break;
    case 'workspaces':
      SwitchedIconComponent = WorkspacesIcon;
      break;
    case 'commerce':
    case 'commerce-branch':
    case 'commerce-branch-v5':
      SwitchedIconComponent = CommerceIcon;
      break;
    case 'developers-branch':
    case 'development':
      SwitchedIconComponent = CRMDevIcon;
      break;
    case 'marketplace':
      SwitchedIconComponent = NewMarketplaceIcon;
      break;
    case 'partner-branch':
    case 'partner-branch-vertical-nav':
      SwitchedIconComponent = PartnerIcon;
      break;
    case GLOBAL_HOME_NAV_ITEM_ID:
      SwitchedIconComponent = HomeIcon;
      break;
    case NAV_ITEM_BOOKMARKS_GROUP_ID:
    case 'favorites':
      SwitchedIconComponent = /*#__PURE__*/memo(props => /*#__PURE__*/_jsx(FavoriteIcon, {
        title: props.title
      }));
      break;

    // Developer Nav items below
    case 'apps':
      SwitchedIconComponent = AppsIcon;
      break;
    case 'developer-projects':
    case 'developer-projects-beta':
      SwitchedIconComponent = DeveloperProjectsIcon;
      break;
    case 'developer-keys':
      SwitchedIconComponent = DeveloperKeysIcon;
      break;
    case 'testing-new':
      SwitchedIconComponent = TestAccountsIcon;
      break;
    case 'api':
      SwitchedIconComponent = DeveloperDocsIcon;
      break;
    case 'developer-home':
    case 'developer-home-updated':
      SwitchedIconComponent = DeveloperHomeIcon;
      break;
    case 'forum':
      SwitchedIconComponent = CommunityForumIcon;
      break;
    default:
      return null;
  }
  return /*#__PURE__*/_jsx(SwitchedIconComponent, {
    title: title
  });
};
export default VerticalNavMenuItemIcon;